import { Button, Grid, Input, Stack } from "@mui/material";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { PaymentAPIService } from "../../services/api";
import { SUBSCRIPTION_PLANS } from "../../shared/constants";

export default function Checkout() {
  const { planName } = useParams();
  const [phone, setPhone] = useState(sessionStorage.getItem("phone"));
  const [plan, setPlan] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    if (!SUBSCRIPTION_PLANS[planName]) {
      navigate("/admin/plans"); // redirect to plans page if invalid
    } else {
      setPlan(SUBSCRIPTION_PLANS[planName]);
    }
  }, [planName]);

  async function handlePay(e) {
    e.preventDefault();

    if (!phone) return alert("Please enter a phone number");

    const { url, error } = await PaymentAPIService.checkout({ ...plan, phone, planName });
    if (error) return alert(error);
    window.location.href = url;
  }

  if (!plan) return null;

  return (
    <Grid
      container
      direction="row"
      sx={{
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <form onSubmit={handlePay}>
        <h2>{plan.label} Plan - ${plan.amount}</h2>

        <Stack spacing={1}>
          <Input
            value={phone}
            type="number"
            size="md"
            variant="outlined"
            onChange={(e) => setPhone(e.target.value)}
            placeholder="Enter phone number" />
          <Button type="submit">Subscribe</Button>
        </Stack>
      </form>
    </Grid>
  );
}